exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-principal/tela-principal.component.scss
// module id = ../../../../../src/app/area-cliente/portal/tela-principal/tela-principal.component.scss
// module chunks = 1